// 公开界面配置加载前/失败时使用；与后端白名单默认值保持一致。
export const DEFAULT_UI_CONFIG = Object.freeze({
  brand_name: '勤发跨境ERP',
  login_welcome: '欢迎回来',
  footer_text: ''
})
